<template>
    <div class="datetime flex flex-align">
        <datetime-picker v-model="value" />
        <!-- <input class="block date" :disabled="disabled" @input="update_date" type="date" :value="date" />
        <input class="block time" :disabled="disabled" @input="update_time" type="time" :value="time" /> -->
    </div>
</template>

<script>
    import moment from 'moment';

    export default {
        name: 'Datetime',
        props: {
            label: String,
            error: Boolean,
            value: Date,
            disabled: Boolean
        },
        computed: {
            time(){
                if(this.value){
                    return moment(this.value).format('HH:mm');
                }

                return '';
            },
            date(){
                if(this.value){
                    return moment(this.value).format('YYYY-MM-DD');
                }

                return '';
            }
        },
        methods: {
            update_date($event){
                const date = moment(`${$event.target.value} ${this.time}`).toDate();

                this.$emit('update:value', date);
                this.$emit('input', date);
            },
            update_time($event){
                const date = moment(`${this.date} ${$event.target.value}`).toDate();

                this.$emit('update:value', date);
                this.$emit('input', date);
            }
        }
    }
</script>

<style scoped lang="less">
    @import "~@/assets/less/variables";

    .datetime
    {
        input
        {
            margin-right: 20px;
            padding-right: 5px;
        }

        .date
        {
            width: 170px;
        }

        .time
        {
            width: 135px;
        }
    }
</style>
